// src/Dashboard/pages/user/DashboardUser/components/CompetitionDetailsDrawer.jsx

import React from "react";
import {
  FaCalendarAlt,
  FaCheckCircle,
  FaMapMarkerAlt,
  FaTrophy,
  FaUser,
} from "react-icons/fa";

import DashboardDrawer from "./DashboardDrawer";
import { formatDateLongFR } from "../utils/dashboardUserUtils";

function InfoRow({ icon: Icon, label, value }) {
  return (
    <div className="flex items-start gap-3 rounded-2xl bg-slate-50 p-4 dark:bg-slate-900">
      <span className="mt-0.5 text-violet-600 dark:text-violet-300">
        <Icon />
      </span>
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
          {label}
        </p>
        <p className="mt-1 text-sm font-semibold text-slate-900 dark:text-white">
          {value || "—"}
        </p>
      </div>
    </div>
  );
}

export default function CompetitionDetailsDrawer({ event, open, onClose }) {
  return (
    <DashboardDrawer
      open={open}
      onClose={onClose}
      title={event?.titre || "Évènement"}
      subtitle={event?.adherentNom ? `Adhérent : ${event.adherentNom}` : ""}
      size="lg"
    >
      {event && (
        <div className="space-y-5">
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <InfoRow
              icon={FaCalendarAlt}
              label="Date"
              value={formatDateLongFR(event.start)}
            />
            <InfoRow
              icon={FaMapMarkerAlt}
              label="Lieu"
              value={event.lieu_event || "Lieu à préciser"}
            />
            <InfoRow
              icon={FaUser}
              label="Adhérent"
              value={event.adherentNom}
            />
            <InfoRow
              icon={FaCheckCircle}
              label="Statut"
              value={event.isValidate ? "Inscription validée" : "Pré-inscription"}
            />
          </div>

          {event.description && (
            <div className="rounded-2xl border border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-900">
              <h3 className="font-bold text-slate-900 dark:text-white">
                Description
              </h3>
              <p className="mt-2 whitespace-pre-line text-sm leading-7 text-slate-600 dark:text-slate-300">
                {event.description}
              </p>
            </div>
          )}

          {(event.resultat || event.classement || event.observations) && (
            <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4 dark:border-emerald-800/60 dark:bg-emerald-900/20">
              <h3 className="flex items-center gap-2 font-bold text-emerald-800 dark:text-emerald-200">
                <FaTrophy />
                Résultats
              </h3>

              <div className="mt-3 space-y-2 text-sm text-emerald-900 dark:text-emerald-100">
                {event.resultat && (
                  <p>
                    <span className="font-bold">Résultat :</span>{" "}
                    {event.resultat}
                  </p>
                )}
                {event.classement && (
                  <p>
                    <span className="font-bold">Classement :</span>{" "}
                    {event.classement}
                  </p>
                )}
                {event.observations && (
                  <p>
                    <span className="font-bold">Observations :</span>{" "}
                    {event.observations}
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </DashboardDrawer>
  );
}